import { FC, useCallback } from 'react';
import { SPACINGS } from 'shared/styles/variables';
import styled, { keyframes } from 'styled-components';

import FormMfaCode, { FormMfaCodeData } from 'dashboard/forms/FormMfaCode';
import { ModalBody, ModalContainer, ModalHeader } from 'dashboard/layouts/ModalLayout';
import { COLORS } from 'dashboard/styles/variables';
import ImageMobileSms from 'images/pictographs/mobile-sms.svg';

const Message = styled.p`
  margin-bottom: ${SPACINGS.base * 2}px;
`;

// adapted from: https://codepen.io/anon/pen/yXeXwG
const vibrate = keyframes`
  0%,
  19% {
    transform: translate3d(0, 0, 0) rotate(0deg);
  }

  20%,
  22%,
  24%,
  26%,
  28%,
  30%,
  32%,
  34% {
    transform: translate3d(-1px, 0, 0) rotate(-5deg);
  }

  21%,
  23%,
  25%,
  27%,
  29%,
  31%,
  33%,
  35% {
    transform: translate3d(1px, 0, 0) rotate(5deg);
  }
  40%,
  100% {
    transform: translate3d(0, 0, 0) rotate(0deg);
  }
`;

const ImageMobileContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: ${SPACINGS.base * 2}px;
`;

const StyledImageMobileSms = styled(ImageMobileSms)`
  height: 100px;
  width: 89px;
  animation: ${vibrate} 2s cubic-bezier(0.36, 0.07, 0.19, 0.97);

  path:nth-child(2) {
    fill: ${COLORS.indigo80};
  }
`;

const CODE_LENGTH = 6;

interface ConfirmMfaPhoneModalProps {
  onClose: () => void;
  onSubmit: (code: string) => Promise<void>;
  onResend: () => Promise<void>;
  resendLoading: boolean;
}

const ConfirmMfaPhoneModal: FC<ConfirmMfaPhoneModalProps> = ({
  onClose,
  onSubmit,
  onResend,
  resendLoading,
}) => {
  const handleSubmit = useCallback(
    async ({ code }: FormMfaCodeData) => {
      await onSubmit(code);
      onClose();
    },
    [onSubmit],
  );

  return (
    <ModalContainer>
      <ModalHeader onClose={onClose}>Confirm phone 2-factor authentication</ModalHeader>

      <ModalBody>
        <ImageMobileContainer>
          <StyledImageMobileSms />
        </ImageMobileContainer>
        <Message>We&apos;ve sent a verification code to your phone.</Message>

        <FormMfaCode
          codeLength={CODE_LENGTH}
          onCancel={onClose}
          onSubmit={handleSubmit}
          onResend={onResend}
          resendLoading={resendLoading}
        />
      </ModalBody>
    </ModalContainer>
  );
};

export default ConfirmMfaPhoneModal;
